/* eslint no-unused-expressions: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

/* import { cssGlobal } from "./cssGlobal"; */

const Html = styled.div`
background: ${props => props.theme.gradient.rightToLeft};
position: relative;
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
  font-display: auto;
  box-sizing: border-box;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
body { 
  color: ${props => props.theme.set.light.p};
  background-color: ${props => props.theme.set.light.bgText};
  min-width: 300px;
  margin: 0px;
}
/*
::selection {
  color: ${props => props.theme.colors.pure.white};
  background-color: ${props => props.theme.colors.warm.base};
}
*/
a {
  border: 0px;
  color: ${props => props.theme.colors.warm.base};
  transition: ${props => props.theme.transitions.main.transition};
  text-decoration: none;
  outline: none;
    &:focus,
    &:hover {
      color: ${props => props.theme.colors.warm.base};
    }
    text-shadow: ${props => props.theme.set.light.shadow.pop};
    color: ${props => props.theme.colors.fire.light};
}
a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
  &:hover,
  &:focus {
    color: inherit;
    text-decoration: none;
  }
  &:focus {
    outline: 0;
  }
}
/*
h1 {
  text-shadow: ${props => props.theme.set.light.shadow.text.small},-1px -1px 0 ${props => props.theme.colors.warm.base},
        1px -1px 0 ${props => props.theme.colors.warm.base},
        -1px 1px 0 ${props => props.theme.colors.warm.base},
        1px 1px 0 ${props => props.theme.colors.warm.base};
}
h2 {
  text-shadow: ${props => props.theme.set.light.shadow.text.small},-1px -1px 0 ${props => props.theme.colors.warm.base},
        1px -1px 0 ${props => props.theme.colors.warm.base},
        -1px 1px 0 ${props => props.theme.colors.warm.base},
        1px 1px 0 ${props => props.theme.colors.warm.base};
}
*/
h1{
  color: ${props => props.theme.set.light.h1};
}
blockquote {
  border-left: 5px solid ${props => props.theme.colors.warm.base};
  padding-left: 1rem !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  font-style: italic;
  p {
    line-height: 1.3 !important;
  }
}


/*
.gatsby-resp-image-wrapper {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.93);
}
.gatsby-resp-iframe-wrapper {
  margin-bottom: 2rem;
}
.gatsby-highlight {
  margin-bottom: 2rem;
} 

*/

iframe, .gatsby-resp-iframe-wrapper {
  scrolling: no;
  frameborder: 0;
}
[tabindex="-1"]:focus {
  outline: none !important;
}
pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
}
figure {
  margin: 0 0 1rem 0;
}
img {
  vertical-align: middle;
}
[role="button"] {
  cursor: pointer;
}
a,
area,
button,
[role="button"],
input,
label,
select,
summary,
textarea {
  touch-action: manipulation;
}
button {
  transition: box-shadow ${props => props.theme.transitions.main.transition};
}

caption {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  color: ${props => props.theme.colors.pure.bright};
  text-align: center;
  caption-side: bottom;
}
label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button:-moz-focus-inner {
  border: 0;
}
button:focus {
  outline: 0px dotted;
  outline: 0px auto -webkit-focus-ring-color;
}
input,
button,
select,
textarea {
  line-height: inherit;
  outline: none;
}
input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
  -webkit-appearance: listbox;
}

p {
  position: relative;
  z-index: 1;
  top: 0px;
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
 
  line-height: inherit;
}
input[type="search"] {
  -webkit-appearance: none;
}
output {
  display: inline-block;
}
[hidden] {
  display: none !important;
}
.headroom-wrapper {
  position: fixed;
  width: 100%;
  z-index: 2000;
  align: center;
  font-size: 1rem;
  .headroom--pinned {
  }
}
.headroom {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  /*
  border-bottom: 2px solid transparent;
  */
  padding: 1rem 1.5rem;
  svg {
    height: 2.5rem;
    g {
    }
  }
}
.headroom--unfixed {
  position: relative;
  transform: translateY(0);
  transition: ${props => props.theme.transitions.headroom.transition};
}
.headroom--scrolled {
  transition: ${props => props.theme.transitions.headroom.transition};
}
.headroom--unpinned {
  position: absolute;
  transform: translateY(-100%);
  transition: ${props => props.theme.transitions.headroom.transition};
}
.headroom--pinned {
  position: fixed;
  transform: translateY(0);
  transition: ${props => props.theme.transitions.headroom.transition};
  box-shadow: ${props => props.theme.set.light.shadow.topNav};

  headroom-wrapper{
  }

/*
nav {
  a {
    border-bottom: 2px solid ${props => props.theme.set.light.highlight};

    color: ${props => props.theme.colors.cool.ink};
    &:hover {
      border-color: ${props => props.theme.colors.cool.ink};
      border-bottom: 2px solid ${props => props.theme.set.light.highlight};
      svg {
        g {
            fill: ${props => props.theme.colors.warm.base};
          }
      }
    }
    &:focus {
      color: ${props => props.theme.colors.cool.lead};
    }
  }
}
*/

  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  svg {
    height: 2.5rem;
    g {
      fill: ${props => props.theme.colors.fire.light};
    }
  }
  span {
    color: ${props => props.theme.colors.cool.ink};
  }
  
`;

const Body = ({ children }) => (
  <React.Fragment>
    <Html>{children}</Html>
  </React.Fragment>
);
export default Body;

Body.propTypes = {
  children: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/layouts/Body.jsx